import { Component, ErrorInfo, ReactNode } from 'react';
import { WarningCircleIcon } from '@phosphor-icons/react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class StatusPageErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Status page error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center">
          <div className="text-center">
            <WarningCircleIcon className="h-12 w-12 text-destructive mx-auto mb-4" />
            <h1 className="text-2xl font-semibold mb-2">
              System Status Unavailable
            </h1>
            <p className="text-muted-foreground">
              We are experiencing technical difficulties.
              <br />
              Please try again later.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
